import {initItemcardImages} from "./default/itemcardImages";
import {initRatingStars} from "../../../default/global/js/rating";
import {triggerCopyLink} from "../../../default/global/js/copyToClipboard";
import {itemcardSubscriptions} from "../../../default/global/js/subscriptions";
import {shareItemcardModal} from "../../../default/global/js/shareItemcard";
import {initVariantSelectionSlider} from "../../../default/global/js/variantSelectionSlider";
import {init360Images} from "../../../default/global/js/init360Images";
import {openFullscreenGallery} from "../../../default/global/js/fullscreengallery";
import {setArticle} from "./custom/setArticle";
import {initRequestArticle} from "./custom/requestArticle";


window.addEventListener("load", (event) => {
    initItemcardImages();
    triggerCopyLink();
    shareItemcardModal();
    initVariantSelectionSlider();
    itemcardSubscriptions();
    setArticle();
    initRequestArticle();

    document.querySelectorAll(".itemcardDescriptionsHeadline").forEach((headline) => {
        headline.addEventListener("click", (event) => {
            event.preventDefault();
            document.querySelectorAll(".itemcardDescriptionsHeadline").forEach((h) => h.classList.remove("active", "wave"));
            headline.classList.add("active", "wave");
            document.querySelectorAll(".itemcardMainDescription").forEach((desc) => desc.classList.remove("active"));
            const target = document.querySelector(`.itemcardMainDescription[data-id="${headline.dataset.target}"]`);
            if (target) target.classList.add("active");
        });
    });

    let i =  0;
    for (const item of document.querySelectorAll(".js-itemcardOpenGallery")) {
        if(!item.dataset.index){
            item.setAttribute("data-index",i);
        }
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item,".js-itemcardOpenGalleryItem");
        });
        i++;
    }
});